import * as React from 'react';
import { Button } from '@helpcenter/analytics-components';
import { useIntl } from 'react-intl';
import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';
import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';
import { token } from '@atlaskit/tokens';
import messages from './messages';

const HELP_CENTER_SEARCH_LIMIT_GATE = 'jsm-kb-help-center-search-limit';
const isHelpCenterSearchLimitEnabled = (): boolean =>
	FeatureGates.checkGate(HELP_CENTER_SEARCH_LIMIT_GATE);

interface BackButtonProps {
	text?: string;
	actionSubjectId: string;
	onClick: () => void;
	allowEmptyText?: boolean;
}

const BackButton = (props: BackButtonProps) => {
	const { formatMessage } = useIntl();
	const { onClick, actionSubjectId, text, allowEmptyText = false } = props;

	if (allowEmptyText && isHelpCenterSearchLimitEnabled()) {
		const defaultBackButtonText = formatMessage(messages.backButtonText);
		const gatedBackButtonText = text === undefined ? defaultBackButtonText : text;
		const accessibleLabel = text ? text : defaultBackButtonText;

		return (
			<Button
				appearance="subtle"
				actionSubjectId={actionSubjectId}
				onClick={onClick}
				aria-label={accessibleLabel}
				iconBefore={
					<ArrowLeftIcon
						label=""
						size="small"
						spacing="compact"
						color={token('color.icon', '#42526E')}
					/>
				}
				data-test-id="back-button"
			>
				{gatedBackButtonText}
			</Button>
		);
	}

	const backButtonText = text ? text : formatMessage(messages.backButtonText);

	return (
		<Button
			appearance="subtle"
			actionSubjectId={actionSubjectId}
			onClick={onClick}
			aria-label={backButtonText}
			iconBefore={
				<ArrowLeftIcon
					label=""
					size="small"
					spacing="compact"
					color={token('color.icon', '#42526E')}
				/>
			}
			data-test-id="back-button"
		>
			{backButtonText}
		</Button>
	);
};

export default BackButton;
